import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
const baseClassName = 'inline-flex items-center justify-center rounded-full bg-brand-green px-7 py-4 text-center text-sm font-bold uppercase tracking-wide text-white shadow-md transition duration-300 hover:-translate-y-0.5 hover:bg-brand-greenDark hover:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green focus-visible:ring-offset-2 md:px-8 md:text-base';
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  if (href) {
    return <a href={href} className={`${baseClassName} ${className}`} data-id="element-39">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={`${baseClassName} ${className}`} data-id="element-40">
      {children}
    </button>;
}